import { useNavigation } from '@react-navigation/core'
import { FC, useEffect, useState } from 'react'
import { useWindowDimensions, View, ViewStyle } from 'react-native'
import { RootStore, useStores } from '../../data/store'
import { getWindow, nativeJSComm, nativeJSMapper } from '../../util/WebFns'

// Assuming you have a component like BottomSheet or a custom Modal for the error
// Since the original code commented out BottomSheet, I'll use `showInvalidQR` state
// to suggest where you would integrate it in your JSX.

const AepsScanQrCode: FC = (props: any) => {
    const {
        sendUniqueDeviceSessionApi,
        agentID
    } = useStores((root) => ({
        sendUniqueDeviceSessionApi: root.agent.sendUniqueDeviceSessionApi,
        agentID: root.agent.agentInfo.agentUserLoginId,
    }))
    // const [sendDeviceInfo, sendUniqueDeviceInfo] = useLazyApiData(sendUniqueDeviceSessionApi)

    console.log("scanqrqrcodeeee")
    const { route } = props

    const isLandscape = () => window.matchMedia('(orientation:landscape)').matches
    const navigation = useNavigation()

    // STATE TO CONTROL ERROR POPUP
    const [showInvalidQR, setInvalidQR] = useState(false)
    const [showPermissionDenied, setShowPermissionDenied] = useState(false)
    const [isScanComplete, setScanComplete] = useState(false)

    const onClose = () => {
        navigation.goBack()
    }

    const onScannerDataFormated = async (data: any) => {
        try {
            console.log(data, "dattttaaa::::");
            const agentInfo = JSON.parse(data);
            if (agentInfo.agentID === agentID) {
                console.log("startapicall");
                const apiResponse = await sendUniqueDeviceSessionApi(
                    agentInfo.hash,
                    agentInfo.agentID,
                    agentInfo.timeStamp,
                );
                console.log(apiResponse, "apiResponse::::::::");
                if (apiResponse.status === "SUCCESS") {
                    console.log("responseeeeeeeee::::")
                    RootStore.message.handleSuccess({
                        message: 'QR Code scanned successfully.',
                        code: 'SCAN_SUCCESS',
                    });
                }
                if (typeof onClose === 'function') {
                    onClose();
                    console.log("onClose called successfully::");
                }

            } else {
                const error = {
                    message: 'Invalid QR, (Please login with your own userID.)',
                    code: 'LOCATION_ERROR',
                };
                RootStore.message.handleError(error);
                if (typeof onClose === 'function') {
                    onClose();
                }
                console.log("onclisecalledd::");
                throw error;
            }
            console.log(agentID, "endddheeeerrreeeeeeeeee::::", agentInfo.hash, agentInfo.agentID, agentInfo.timeStamp);

        } catch (error) {
            console.error("Error in onScannerDataFormated:", error);
            if (!error.code) {
                RootStore.message.handleError({
                    message: 'QR Code data is invalid or corrupted. Please scan a valid QR code.',
                    code: 'SCAN_PARSE_ERROR',
                });
            }
            if (typeof onClose === 'function') {
                onClose();
            }
        }
    }

    const onScanError = (error: any) => {
        navigation.goBack()
        console.log(error, "error::")
    }

    useEffect(() => {
        if (getWindow().AepsWebViewInterface) {
            nativeJSComm(nativeJSMapper.QrScanner, onScannerDataFormated, onScanError)
        }
        console.log("nativeJSCALLEDDDD::")
    }, [])

    const data = route?.params?.data ?? undefined
    const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = useWindowDimensions()
    const mStyles = styles(SCREEN_WIDTH, SCREEN_HEIGHT)

    return (
        <View style={{ flex: 1 }}>
        </View>
    )
}

export { AepsScanQrCode }

const styles = (width: number, height: number) => {
    return {
        holeStyle: {
            position: 'absolute',
            alignItems: 'center',
            justifyContent: 'center',
            left: width / 2 - 128,
            top: height / 2 - 128,
            width: 256,
            height: 256,
            boxShadow: `0px 0px 0px ${height}px rgba(0, 0, 0, .8)`,
            borderRadius: 8,
        } as ViewStyle,
    }
}